import React from "react";

export enum USER_ROLE {
  ADMIN = "CannabisConnect",
  AGLC = "CannabisAGLC",
  DEFAULT = "Cannabis",
  MANAGEUSERS = "ManageCannabisAccountUsers",
  RUNREPORTS = "RunReports",
  NOT_SET = "-1",
}

export const getHighestPriviligeRoleLabel = (roles: USER_ROLE[]): string => {
  if (roles.find((r) => r.toLowerCase() === USER_ROLE.ADMIN.toLowerCase())) {
    return 'ADMIN';
  } else if (roles.find((r) => r.toLowerCase() === USER_ROLE.AGLC.toLowerCase())) {
    return 'AGLC';
  } 

  return '';
}

export const getRoleName = (role: USER_ROLE): string => {
  switch (role) {
    case USER_ROLE.ADMIN:
      return 'ADMIN';
    case USER_ROLE.AGLC:
      return 'AGLC';
            case USER_ROLE.DEFAULT:
      return "Cannabis User";
            case USER_ROLE.MANAGEUSERS:
      return "User Manager";
            case USER_ROLE.RUNREPORTS:
  }

  return "Report Viewer";
}

export const CanEdit = (roles: USER_ROLE[]) => {
  //regular user (For own) or admin (For all)
  return roles.some((r) => r.toLowerCase() === USER_ROLE.ADMIN || USER_ROLE.DEFAULT.toLowerCase());
};

interface RoleContextInterface {
  roles: USER_ROLE[];
  setRoles: (names: USER_ROLE[]) => void;
}

const role = {
  roles: [USER_ROLE.DEFAULT],
  setRoles: (names: USER_ROLE[]) => { role.roles = names; },
};

const RoleContext = React.createContext<RoleContextInterface>(role);
RoleContext.displayName = "RoleContext";

export default RoleContext;
